import { Component, OnInit } from '@angular/core';
import { ResponsiveService } from '../../../services/responsive.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

    public linkGroups;

    constructor(public responsiveService: ResponsiveService) {
    }

    ngOnInit() {
        this.linkGroups = [
            {
                title: 'Phone plans',
                items: [
                    {name: 'Careers', url: '#'},
                    {name: 'Press', url: '#'},
                    {name: 'Policies', url: '#'},
                    {name: 'Help', url: '#'},
                    {name: 'Diversity & Belonging', url: '#'},
                ]
            },
            {
                title: 'Discover',
                items: [
                    {name: 'Trust & Safety', url: '#'},
                    {name: 'Travel Credit', url: '#'},
                    {name: 'Airbnb Citizen', url: '#'},
                    {name: 'Business Travel', url: '#'},
                    {name: 'Guidebooks', url: '#'},
                    {name: 'Airbnbmag', url: '#'},
                ]
            },
            {
                title: 'Hosting',
                items: [
                    {name: 'Why host', url: '#'},
                    {name: 'Hospitality', url: '#'},
                    {name: 'Responsible Hosting', url: '#'},
                    {name: 'Community Centre', url: '#'},
                ]
            }
        ]
    }

}



// WEBPACK FOOTER //
// /Users/avihayev/Phone-Plans/Lading Page/landing-page-web/src/app/components/view/footer/footer.component.ts